(() => {
    function fixHulkIframe() {
        const hulkDivs = document.querySelectorAll('.pxFormGenerator');
        if (!hulkDivs.length > 0) return
        const FORM_URL = 'https://formbuilder.hulkapps.com';
        const UTM_REGEX = /(?!&)utm_[^=]*=[^&]*(?=)/g;
        hulkDivs.forEach(div => {
            const searchParams = location.search.slice(1).match(UTM_REGEX);
            let utmParams = searchParams ? searchParams.join('&') : '';
            const referrerUrl = location.href.trim();

            if (utmParams) {
                if (!utmParams.includes('utm_source')) {
                    utmParams = `utm_source=hulkapps-form-builder-app&${utmParams}`;
                }
            }

            const iframe = document.createElement('iframe');
            iframe.width = '100%';
            iframe.frameBorder = '0';

            const id = div.id;
            iframe.id = `frame_${id}`;

            const baseSrc = `${FORM_URL}/corepage/customform?id=${id}&referrer_url=${encodeURIComponent(referrerUrl)}`;

            Object.defineProperty(iframe, 'src', {
                value: utmParams ? `${baseSrc}&${utmParams}` : baseSrc,
                writable: false,
                configurable: false,
            });
            iframe.setAttribute('src', iframe.src);

            div.innerHTML = '';
            div.appendChild(iframe);
        });
    }

    const hook = setInterval(()=>{
        let formDiv = document.querySelector('.pxFormGenerator');
        if (formDiv && typeof window.GetCorePage === 'function'){
            clearInterval(hook);
            fixHulkIframe();
            window.GetCorePage();
            let messageIteration = 0;
            window.addEventListener('message',(e)=>{
                if (e.data.formid){
                    messageIteration++;
                    if (messageIteration == 2){
                        const fakeEl = document.querySelector('.hulk-formbuilder-skeleton-loader-container');
                        fakeEl.style.position = 'absolute';
                        fakeEl?.remove();
                    }
                }
            })
        }
        setTimeout(()=>{
            clearInterval(hook);
        },8000);
    })
})();